import type { CSSProperties } from 'react'
import { cn } from '@/lib/utils'
import type { Baris } from './format'

interface HasilBarisProps {
  baris: Baris
  /** Position in its list, for the 18 ms stagger (capped at 12 by motion.css). */
  index: number
  className?: string
}

/** The middle dot between facts; only on a laptop, where the row is one line of text. */
function Titik() {
  return (
    <span aria-hidden="true" className="hidden text-muted md:inline">
      {' · '}
    </span>
  )
}

/**
 * One result on a hairline: on a laptop one 14 px line of text in CONTENT's order
 * ("Surat Baptis · Yohanes Yufuwai · 3 Sep 2026 · Paroki … · Buku II/47/812") that wraps
 * at its dots like a sentence, the person's name at 500; on a phone the same facts
 * stacked as a card, lead word in label ink, name in body. Enters with the 200 ms rise.
 */
export function HasilBaris({ baris, index, className }: HasilBarisProps) {
  const style = { '--i': index } as CSSProperties
  return (
    <li
      style={style}
      className={cn(
        'enter flex flex-col gap-1 border-hairline border-b py-3 text-table md:block',
        className,
      )}
    >
      <span className="text-label text-muted md:text-table md:text-text">{baris.judul}</span>
      {baris.nama !== null && (
        <>
          <Titik />
          <span className="font-medium text-body text-text md:text-table">{baris.nama}</span>
        </>
      )}
      {baris.rincian.length > 0 && (
        <>
          <Titik />
          <span className="text-muted md:text-text">
            {baris.rincian.map((part, i) => (
              <span key={part}>
                {i > 0 && (
                  <span aria-hidden="true" className="text-muted">
                    {' · '}
                  </span>
                )}
                <span className="num">{part}</span>
              </span>
            ))}
          </span>
        </>
      )}
      {baris.keterangan !== null && (
        <span className="text-text md:mt-1 md:block">{baris.keterangan}</span>
      )}
    </li>
  )
}
